import PropTypes from "prop-types";
import React from "react";
import styles from "./feeds-seo-most-wanted.css";

function FeedsSeoMostWanted({ mostWanted }) {
    let title = null;
    if (mostWanted.title) {
        title = <h3>{mostWanted.title}</h3>;
    }

    let items = null;
    if (mostWanted.items.length > 0) {
        items = (
            <ul>
                {mostWanted.items.map((item, index) => {
                    if (item.title || item.body) {
                        let image = null;
                        if (item.img) {
                            image = (
                                <figure className={styles.mostWantedFigure}>
                                    <img className={styles.mostWantedImg} src={item.img} />
                                </figure>
                            );
                        }

                        let pricing = null;
                        if (item.link && item.pricing) {
                            pricing = (
                                <a href={item.link} className={styles.mostWantedPricing}>
                                    {item.pricing}
                                </a>
                            );
                        } else if (item.pricing) {
                            pricing = <p className={styles.mostWantedPricing}>{item.pricing}</p>;
                        }

                        return (
                            <li className={styles.mostWantedItem} key={index}>
                                {image}
                                <div>
                                    <h3 className={styles.mostWantedTitle}>{item.title}</h3>
                                    <div
                                        className={styles.mostWantedBody}
                                        dangerouslySetInnerHTML={{ __html: item.body }}
                                    />
                                    {pricing}
                                </div>
                            </li>
                        );
                    }
                })}
            </ul>
        );
    }

    if (title || items) {
        return (
            <div className={styles.mostWanted}>
                {title}
                {items}
            </div>
        );
    }

    return null;
}

FeedsSeoMostWanted.propTypes = {
    mostWanted: PropTypes.shape({
        title: PropTypes.string,
        items: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string,
                body: PropTypes.string,
                pricing: PropTypes.string,
                img: PropTypes.string,
                link: PropTypes.string,
            })
        ),
    }),
};

export default FeedsSeoMostWanted;
